exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".input-wrapper {\n  position: relative; }\n\n.input-icon {\n  position: absolute;\n  color: black;\n  margin-top: 1.1em;\n  font-size: 14px;\n  -ms-flex-pack: right;\n      justify-content: right;\n  display: -ms-flexbox;\n  display: flex;\n  width: 30%;\n  -ms-flex-pack: end;\n      justify-content: flex-end;\n  padding-right: 5px;\n  margin-left: 70%;\n  padding-bottom: 30px; }\n\n[hidden] {\n  display: none !important; }\n\n.fas {\n  margin-right: 5px;\n  cursor: pointer; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/ssn-module/ssn/ssn.component.scss
// module id = 2198
// module chunks = 66